module.exports = __webpack_public_path__ + "static/media/8OLA25.bb32a830.jpg";